import { Directive, Input, ElementRef, OnInit } from "@angular/core";
import { DropzoneService } from "@app/core/services/dropzone.service";
import { I18nService } from "@app/shared/i18n/i18n.service";

import * as Dropzone from "dropzone";
// Dropzone.autoDiscover = false;
@Directive({
  selector: '[saDropzone]'
})
export class DropzoneDirective implements OnInit {
  @Input() saDropzone: any;
  dropZoneFiles=[];
  private dropzone: any;
  fileData;
  constructor(private el: ElementRef,private dropzoneService:DropzoneService,private i18nService: I18nService) {
      setTimeout(() => {
        // this.initEdiDropzone()
        // this.initpdfDropzone()
        this.initDropzone()
      });

  }
  initDropzone() {
    let self = this;
    Dropzone.autoDiscover = false;
    this.dropzone = new Dropzone(this.el.nativeElement, this.saDropzone || {});
    this.dropzone.on("addedfile", function (event) {
      setTimeout(() => {
        // self.fileDetails();
        // self.dropzoneService.sendFilesName(self.dropzone.files);
        // self.dropzoneService.pdfUploadCount(self.dropzone.files.length);
        if((self.dropzone.element.length > 5))
        {
          if(self.dropzone.element[6]?.defaultValue == 'pdfToXml'){
            self.dropzoneService.pdfUploadCount(self.dropzone.files.length);     
            self.dropzoneService.sendFilesName(self.dropzone.files);  
          } 
          else{
            self.dropzoneService.invoiceUploadCount(self.dropzone.getQueuedFiles().length);
            // self.dropzoneService.csvUploadCount(self.dropzone.getQueuedFiles().length);
          }
        }else{
          self.dropzoneService.invoiceUploadCount(self.dropzone.getQueuedFiles().length);
          self.dropzoneService.sendEdiFilesName(self.dropzone.files[0].name);
          // self.dropzoneService.csvUploadCount(self.dropzone.getQueuedFiles().length);
          self.dropzoneService.sendbulkImportsFileName(self.dropzone.files[0].name);
          self.dropzoneService.sendFilesName(self.dropzone.files);
        }
        // self.dropzoneService.sendFilesName(self.dropzone.files);
      }, 1000);
      
    });
    this.dropzone.on("removedfile", function (event) {
      self.dropzoneService.deletedFile(event.dropId);
      setTimeout(() => {
        self.dropzoneService.invoiceUploadCount(self.dropzone.getQueuedFiles().length);
        self.dropzoneService.sendFilesName(self.dropzone.files);
        self.dropzoneService.pdfUploadCount(self.dropzone.files.length);
        // self.dropzoneService.csvUploadCount(self.dropzone.getQueuedFiles().length);
        // self.dropzoneService.sendcsvsFileName(self.dropzone.files);
        self.dropzoneService.bulkinviteRemove(self.dropzone.files.length);
      }, 1000);
    });
    this.dropzone.on("maxfilesexceeded", function (file, event, $event) {
      self.fileData.push(file);
      let message = self.i18nService.getTranslation('common_all_dropze_upload_error_more_files').replace("[count]", self.saDropzone.maxFiles);
      $(file.previewElement).find('.dz-error-message').text(message)
    });  
    // this.dropzone.off("queuecomplete").on("queuecomplete",function(){
    //   self.dropzoneService.bulkImportuploadSuccessMessage("success");  
    // });
  }
  initEdiDropzone() {
    let self = this;
    Dropzone.autoDiscover = false;
    
    this.dropzone = new Dropzone(this.el.nativeElement, this.saDropzone || {});
    this.dropzone.on("addedfile", function (event) {
      setTimeout(async () => {
        self.dropzoneService.sendEdiFilesName(self.dropzone.files[0].name);
        self.dropzoneService.invoiceUploadCount(self.dropzone.getQueuedFiles().length);

      }, 1000);
    });
    this.dropzone.on("removedfile", function (event) {
      setTimeout(() => {
        self.dropzoneService.invoiceUploadCount(self.dropzone.getQueuedFiles().length);
        self.dropzoneService.sendEdiFilesName(self.dropzone.files);
        // self.dropzoneService.pdfEdiUploadedCount(self.dropzone.files.length);
      }, 1000);
    });
    
  }
  initpdfDropzone(){
    let self = this;
    Dropzone.autoDiscover = false;
    
    this.dropzone = new Dropzone(this.el.nativeElement, this.saDropzone || {});
    this.dropzone.on("addedfile", function (event) {
      setTimeout(async () => {
        self.dropzoneService.sendFilesName(self.dropzone.files);
        self.dropzoneService.pdfUploadCount(self.dropzone.files.length);
        // self.dropzoneService.pdfUploadCount(self.dropzone.getQueuedFiles().length);
      }, 1000);
    });
    this.dropzone.on("removedfile", function (event) {
      setTimeout(() => {
        self.dropzoneService.sendFilesName(self.dropzone.files);
        self.dropzoneService.pdfUploadCount(self.dropzone.files.length);
        // self.dropzoneService.pdfUploadCount(self.dropzone.getQueuedFiles().length);
      }, 1000);
    });
    
  }

 
  ngOnInit() {
    // this.bulkInvitation()
    let self = this;
    let files;
    let fileDetails;
    setTimeout(() => {
      if (!this.dropzone) return;

      this.dropzoneService.uploadFiles.subscribe((data:any) => {
        switch (data) {
          case "clear":
            this.dropzone.removeAllFiles();
            break;
          case "clearpdf":
            this.dropzone.removeAllFiles();
            break;
          case "upload":
            this.dropzone.on("sending", function (file, xhr, formData) {
            });
            this.dropzone.off("success").on("success", function (event,msg) {
              self.dropzoneService.invoiceCreated("success");
              self.dropzoneService.reponse(msg);
            });
            this.dropzone.off("error").on("error", function (event,msg) {
              self.dropzoneService.invoiceCreated("error");
              self.dropzoneService.reponse(msg);
            });
           
            this.dropzone.processQueue();
            break;
          case "uploadpdf":
            this.dropzone.on("sendingmultiple", function (file, xhr, formData) {
            });
            this.dropzone.off("success").on("success", function (event,msg) {
              self.dropzoneService.pdfCreated("success");
              self.dropzoneService.pdfreponse(msg);
            });
            // this.dropzone.on('error', function (file, errorMessage) {
            //   var errorDisplay = document.querySelectorAll('[data-dz-errormessage]');
            //   $(errorDisplay).each(function (index) {
            //     if ($(this).text() == 'Server responded with 0 code.') {
            //       errorDisplay[index].innerHTML = self.i18nService.getTranslation('common_all_dropze_upload_error');
            //     }
            //   });
            // });
            // this.dropzone.off("error").on("error", function (event,msg) {
            //   self.dropzoneService.pdfCreated("error");
            //   self.dropzoneService.pdferrorreponse(msg);
            // });
            // this.dropzoneService.pdfCreated("success");
            this.dropzone.processQueue();
            break;
          }
      });

      this.dropzoneService.uploadPdf.subscribe((data:any) => {
      switch (data) {
        case "clear":
          this.dropzone.removeAllFiles();
          break;
        case "uploadpdf":
          this.dropzone.on("sendingmultiple", function (file, xhr, formData) {
          });
          this.dropzone.off("success").on("success", function (event,msg) {
            self.dropzoneService.pdfCreated("success");
            self.dropzoneService.pdfreponse(msg);
          });
          // this.dropzone.on('error', function (file, errorMessage) {
          //   var errorDisplay = document.querySelectorAll('[data-dz-errormessage]');
          //   $(errorDisplay).each(function (index) {
          //     if ($(this).text() == 'Server responded with 0 code.') {
          //       errorDisplay[index].innerHTML = self.i18nService.getTranslation('common_all_dropze_upload_error');
          //     }
          //   });
          // });
          // this.dropzone.off("error").on("error", function (event,msg) {
          //   self.dropzoneService.pdfCreated("error");
          //   self.dropzoneService.pdferrorreponse(msg);
          // });
          // this.dropzoneService.pdfCreated("success");
          this.dropzone.processQueue();
          break;

        }
      })
      this.dropzoneService.bulkImportFiles.subscribe((data:any) => {
        switch (data) {
          case "clear":
            this.dropzone.removeAllFiles();
            break;
          case "clearcsv":
            this.dropzone.removeAllFiles();
            break;
          case "upload":
            this.dropzone.on("sending", function (file, xhr, formData) {
            });
            this.dropzone.off("success").on("success", function (event,msg) {
              self.dropzoneService.bulkinvitationCreated("success");
              // self.dropzoneService.reponse();
              self.dropzoneService.bulkinvitereponse(msg);
            });
           
            this.dropzone.processQueue();
            break;
         
          }
      });

      this.dropzone.on("removedfile", function (event) {
        self.dropzoneService.deletedFile(event.dropId);
        setTimeout(() => {
          self.dropzoneService.invoiceUploadCount(self.dropzone.getQueuedFiles().length);
          self.dropzoneService.sendFilesName(self.dropzone.files);
          self.dropzoneService.pdfUploadCount(self.dropzone.files.length);
        }, 1000);
      });
    });
  }
  // bulkInvitation(){
  //   let self = this;
  //   let files;
  //   let fileDetails;
  //   this.dropzoneService.bulkImportFiles.subscribe((data:any) => {
  //     switch (data) {
  //       case "clear":
  //         this.dropzone.removeAllFiles();
  //         break;
  //       case "clearcsv":
  //         this.dropzone.removeAllFiles();
  //         break;
  //       case "upload":
  //         this.dropzone.on("sending", function (file, xhr, formData) {
  //         });
  //         this.dropzone.off("success").on("success", function (event,msg) {
  //           self.dropzoneService.bulkinvitationCreated("success");
  //           // self.dropzoneService.reponse();
  //           self.dropzoneService.bulkinvitereponse(msg);
  //           console.log(msg);
            
  //         });
         
  //         this.dropzone.processQueue();
  //         break;
       
  //       }
  //   });

  //   this.dropzone.on("removedfile", function (event) {
  //     self.dropzoneService.deletedFile(event.dropId);
  //     setTimeout(() => {
  //       self.dropzoneService.invoiceUploadCount(self.dropzone.getQueuedFiles().length);
  //       self.dropzoneService.sendFilesName(self.dropzone.files);
  //       self.dropzoneService.pdfUploadCount(self.dropzone.files.length);
  //     }, 1000);
  //   });
  // }
  async readFile(file){
    return new Promise(resolve => {
      if (file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        // reader.readAsText(file);
        reader.onload = function (evt) {
          resolve(evt.target.result)
        }
        reader.onerror = function (evt) {
          resolve(false)

        }
      }
    })
  }
  // fileDetails(){
  //   let fileItems=[];
  //   if(this.dropzone.element.length>0){
  //     console.log(this.dropzone);
  //     console.log(this.dropzone.files);

      
  //     this.dropzone.files.forEach((ele,index)=>{
  //     ele.previewElement.id=index;
  //       fileItems.push(ele);
  //     });
  //     this.dropzoneService.bulkImportFilesName(fileItems);
  //   }
  // }
}
